import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { MdArrowLeft, MdVisibility } from 'react-icons/md';
import { MdVisibilityOff } from 'react-icons/md';
import { MdLock } from 'react-icons/md';
import axios from 'axios';
import { web_url } from '../../constant';


function ForgotPasswordPage2() {

    const [language, setLanguage] = useState(() => {
        const categoryNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return categoryNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);
    const navigate = useNavigate();

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    const location = useLocation();
    const [email, setEmail] = useState("");

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const userEmail = params.get("userEmail");
        const token = params.get("resetToken");
        let category = (params.get("userRole") || "STUDENT").toUpperCase();
        // let category = (localStorage.getItem('category')).toUpperCase();
        if (userEmail) {
            setEmail(userEmail);
            setIsLoading(true);



            axios.get(`${web_url}/api/auth/validate-reset-token?userEmail=${userEmail}&userRole=${category}&token=${token}`).then((resToken) => {
                console.log('res', resToken.data);
                console.log('res1', resToken);
                if (resToken.data.toLowerCase().includes('you have not requested a password change')) {
                    setIsLoading(false);
                    // handleClickOpenError('you have not requested a password change')
                } else {
                    setIsLoading(false);
                }
            }).catch((errFor) => {
                console.log("eee", errFor);

                setIsLoading(false);
                if (errFor.response.data) {
                    // console.log(errFor.response.data)
                    if (errFor.response.data) {
                        handleClickOpenError(errFor.response.data);
                    } else if (errFor.response.data.message) {
                        handleClickOpenError(errFor.response.data.message);
                    } else if (errFor.response.data.token) {
                        handleClickOpenError(errFor.response.data.token);
                    } else {
                        handleClickOpenError("An unknown error occured");
                    }

                }
            })
        }
        // else if (!userEmail || !category) {
        //     localStorage.clear();
        //     navigate('/loginas')
        // }
    }, [location.search]);

    const [userNewPasswordDetails, setUserNewPasswordDetails] = useState(
        {
            password: '',
            confirmPassword: '',
        }
    )
    const [openError, setOpenError] = useState(false);
    const [error, setError] = useState('');

    const handleClickOpenError = (err) => {
        // console.log(err);

        if (err.toLowerCase().includes('internal server error')) {
            setError(t('t93'));
        } else if (err.toLowerCase().includes('not found with the provided email')) {
            setError(t('t349'));
        } else if (err.toLowerCase().includes('you have not requested a password change')) {
            setError(t('t274'));
        } else if (err.toLowerCase().includes('invalid credentials')) {
            setError(t('t100'));
        } else {
            setError(t('t94'));
        }
        setOpenError(true);
    };

    const handleCloseError = () => {
        setOpenError(false);
        localStorage.removeItem('/')
        navigate('/loginas')
    };

    const [errors, setErrors] = useState(
        {
            noPassword: false,
            passwordsNotMatch: false,
        }
    )

    const handleContinue = () => {
        // console.log(userNewPasswordDetails);

        let newErrors = {};

        newErrors.noPassword = !userNewPasswordDetails.password;

        if (userNewPasswordDetails.password && (userNewPasswordDetails.confirmPassword) !== (userNewPasswordDetails.password)) {
            newErrors.passwordsNotMatch = true;
        } else {
            newErrors.passwordsNotMatch = false;
        }

        setErrors(newErrors);

        if (Object.values(newErrors).some((error) => error)) {
            return;
        }
        const params = new URLSearchParams(location.search);
        const userEmail = params.get("userEmail");
        const token = params.get("resetToken");
        let category = (params.get("userRole") || "STUDENT").toUpperCase();
        const user = {
            newPassword: userNewPasswordDetails.password,
            userRole: category,
            token: token
        };

        setIsLoading(true);

        const config = {
            headers: {
                'Content-Type': 'application/json',
            },
        };
        setIsLoading(true);
        axios.put(`${web_url}/api/auth/change-forget-password/${userEmail}`, user, config).then((resChange) => {
            setIsLoading(false);
            setOpen2(true);

        }).catch((errChaneg) => {
            setIsLoading(false);
            console.log(errChaneg);

            if (errChaneg?.response?.data) {
                // console.log(errFor.response.data)
                if (errChaneg.response.data) {
                    handleClickOpenError(errChaneg.response.data);
                } else if (errChaneg.response.data.message) {
                    handleClickOpenError(errChaneg.response.data.message);
                } else if (errChaneg.response.data.token) {
                    handleClickOpenError(errChaneg.response.data.token);
                } else {
                    handleClickOpenError("An unknown error occured");
                }

            }
        })
    }

    const [isVisible, setIsVisible] = useState(false);
    const [isVisibleText, setIsVisibleText] = useState(true);

    const [isVisible2, setIsVisible2] = useState(false);
    const [isVisibleText2, setIsVisibleText2] = useState(true);

    const handleVisiblityClick = () => {
        setIsVisible(!isVisible);
        if (!isVisible && userNewPasswordDetails.password.length > 0) {
            setIsVisibleText(true);
        } else if (isVisible && userNewPasswordDetails.password.length > 0) {
            setIsVisibleText(false);
        }
    }

    const handleVisiblityClick2 = () => {
        setIsVisible2(!isVisible2);
        if (!isVisible2 && userNewPasswordDetails.password.length > 0) {
            setIsVisibleText2(true);
        } else if (isVisible2 && userNewPasswordDetails.password.length > 0) {
            setIsVisibleText2(false);
        }
    }

    const [passwordStatus, setPasswordStatus] = useState({
        weak: false,
        medium: false,
        strong: false
    })

    const errorMessages =
        [
            '',
            t('t60'),
            t('t61'),
            t('t62'),
            t('t63'),
            t('t64'),
        ]

    const [errorMessageNumber, setErrorMessageNumber] = useState(0)

    const regexPatterns = [
        /^.{1,7}$/,  // weak password
        /^(?:[a-z]{8,}|[A-Z]{8,}|[0-9]{8,}|[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{8,})$/,  // medium password
        /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#*$%^&+=]).{8,}$/,  // strong password
        /(?=.*[A-Z])/,  // contains at least 1 uppercase letter
        /(?=.*[a-z])/,  // contains at least 1 lowercase letter
        /(?=.*[0-9])/,  // contains at least 1 numeric digit
        /(?=.*[!@#*$%^&+=])/,  // contains at least 1 special character
        /^.{8,}$/,  // password length greater than 8 characters
    ];

    const [isLoading, setIsLoading] = useState(false);
    const [open2, setOpen2] = useState(false);

    const handleClose2 = () => {
        setOpen2(false);
    };

    return (
        <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} bg-bgImg md:bg-bglarge bg-no-repeat bg-cover bg-opacity-[10] h-screen w-screen flex flex-col  md:items-center`}>
            <div className="fixed inset-0 bg-white/50 z-0"></div>
            <Menu as="div" className="absolute top-0 right-0 m-[10px] text-left items-right z-20">
                <div>
                    <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-black hover:bg-gray-50">
                        {language === "Sinhala" ? "සිංහල" : (language === "Tamil" ? "தமிழ்" : language)}
                        <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 text-gray-400" />
                    </MenuButton>
                </div>

                <MenuItems
                    transition
                    className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                >
                    <div className="py-1">
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("English");
                                    changeLanguage('en')
                                }}
                            >
                                English
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("Sinhala");
                                    changeLanguage('si')
                                }}
                            >
                                සිංහල
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("Tamil");
                                    changeLanguage('ta')
                                }}
                            >
                                தமிழ்
                            </button>
                        </MenuItem>
                    </div>
                </MenuItems>
            </Menu>
            <div className='relative z-10 h-auto  w-full'>
                <div className='flex items-center justify-start mt-[20px] xl:mt-[100px] 2xl:mt-[150px] xl:ml-[170px] 2xl:ml-[250px]' >
                    <MdArrowLeft className='text-[25px] md:text-[35px] lg:text-[33px] xl:text-[25px] 2xl:text-[22px]' />
                    <button className={`z-10 hover:underline font-bold ${i18n.language === "en" ? "text-[17px] md:text-[23px] lg:text-[23px] xl:text-[15px] 2xl:text-[22px]" : (i18n.language === "si" ? "text-[14px] md:text-[19px] lg:text-[21px] xl:text-[13px] 2xl:text-[18px]" : "text-[14px] md:text-[19px] lg:text-[20px] xl:text-[13px] 2xl:text-[18px]")}`} onClick={() => {
                        navigate('/loginas');
                    }}>
                        {t('t455')}
                    </button>
                </div>
                <div className='pl-[30px] pr-[30px] flex flex-col justify-start items-center h-full w-full absolute top-[10vh] md:top-[13vh] xl:top-[14vh] 2xl:top-[17vh]'>
                    <div className='w-full md:w-[400px] lg:w-[500px] xl:w-[550px]  2xl:w-[500px] flex flex-col items-center justify-center'>
                        <img src="/images/changed.svg" className="h-[150px]" alt='logo' />
                        <p className="text-center text-[20px] mt-[10px]">{t('t76')}</p>

                        {
                            isLoading ?
                                <div className="items-center justify-center flex pt-[30px]">
                                    <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                                </div> :
                                <>
                                    <div className="w-full items-center mt-[20px] flex rounded-md bg-[#F1F6FB] pl-[10px] pr-[20px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                        <MdLock size="26px" color="#8189B0" />
                                        <input
                                            type={isVisibleText ? "text" : "password"}
                                            name="password"
                                            className={`ml-[10px] mr-[10px] w-full bg-[#F1F6FB] text-gray-900 text-[15px] ${isVisibleText ? 'text-[15px] tracking-wide' : 'text-[25px] tracking-widest'} placeholder:text-[#8189B0] focus:outline focus:outline-0`}
                                            placeholder={t('t17')}
                                            value={userNewPasswordDetails.password}
                                            onChange={(e) => {

                                                const inputValue = e.target.value.replace(/\s+/g, '').trim();
                                                if (inputValue !== "") {
                                                    setErrors((prev) => ({ ...prev, noPassword: false }));
                                                    if (regexPatterns[2].test(inputValue)) {
                                                        setPasswordStatus((prev) => ({ ...prev, medium: false, weak: false, strong: true }));

                                                    } else if (regexPatterns[1].test(inputValue)) {
                                                        setPasswordStatus((prev) => ({ ...prev, medium: true, weak: false, strong: false }));

                                                    } else if (regexPatterns[0].test(inputValue)) {
                                                        setPasswordStatus((prev) => ({ ...prev, medium: false, weak: true, strong: false }));

                                                    } else {
                                                        setPasswordStatus((prev) => ({ ...prev, medium: true, weak: false, strong: false }));

                                                    }
                                                } else {
                                                    setErrors((prev) => ({ ...prev, noPassword: false }));
                                                    setPasswordStatus((prev) => ({ ...prev, medium: false, weak: false, strong: false }));
                                                }

                                                if (inputValue !== '') {
                                                    if (!regexPatterns[3].test(inputValue)) {
                                                        setErrorMessageNumber(1)
                                                    } else if (!regexPatterns[4].test(inputValue)) {
                                                        setErrorMessageNumber(2)
                                                    } else if (!regexPatterns[5].test(inputValue)) {
                                                        setErrorMessageNumber(3)
                                                    } else if (!regexPatterns[6].test(inputValue)) {
                                                        setErrorMessageNumber(4)
                                                    } else if (!regexPatterns[7].test(inputValue)) {
                                                        setErrorMessageNumber(5)
                                                    } else {
                                                        setErrorMessageNumber(0)
                                                    }
                                                } else {
                                                    setErrorMessageNumber(0)
                                                }

                                                setUserNewPasswordDetails((prevState) => ({
                                                    ...prevState, password: inputValue
                                                }));
                                                if (!isVisible && inputValue.length > 0) {
                                                    setIsVisibleText(false);
                                                } else {
                                                    setIsVisibleText(true);
                                                }
                                            }}
                                        />
                                        {
                                            isVisible ? <MdVisibilityOff onClick={handleVisiblityClick} size="24px" color="#8189B0" /> : <MdVisibility onClick={handleVisiblityClick} size="24px" color="#8189B0" />
                                        }
                                    </div>

                                    {errors.noPassword &&
                                        <div className='w-full flex justify-start items-start'>
                                            <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t18')}</p>
                                        </div>
                                    }

                                    {passwordStatus.weak &&
                                        <div className='w-full flex justify-start items-start'>
                                            <p className='text-black text-[12px] mt-[5px] '>{t('t65')}<span className='text-[#fc0000] font-bold'>{t('t66')}</span></p>
                                        </div>
                                    }
                                    {passwordStatus.medium &&
                                        <div className='w-full flex justify-start items-start'>
                                            <p className='text-black text-[12px] mt-[5px]'>{t('t65')}<span className='text-[#fc8600] font-bold'>{t('t67')}</span></p>
                                        </div>
                                    }
                                    {passwordStatus.strong && <div className='w-full flex justify-start items-start'>
                                        <p className='text-black text-[12px] mt-[5px]'>{t('t65')}<span className='text-[#099509] font-bold'>{t('t68')}</span></p>
                                    </div>
                                    }

                                    {errorMessageNumber !== 0 &&
                                        <div className='w-full flex justify-start items-start'>
                                            <p className='text-[#ff0000] text-[12px] mt-[5px] '>{errorMessages[errorMessageNumber]}</p>
                                        </div>
                                    }

                                    <div className="w-full items-center mt-[20px] flex rounded-md bg-[#F1F6FB] pl-[10px] pr-[20px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                        <MdLock size="26px" color="#8189B0" />
                                        <input type={isVisibleText2 ? "text" : "password"}
                                            name="password_confirm"
                                            className={`ml-[10px] mr-[10px] w-full bg-[#F1F6FB] text-gray-900 text-[15px] ${isVisibleText2 ? 'text-[15px] tracking-wide' : 'text-[25px] tracking-widest'} placeholder:text-[#8189B0] focus:outline focus:outline-0`}
                                            placeholder={t('t30')}
                                            value={userNewPasswordDetails.confirmPassword}
                                            onChange={(e) => {
                                                const inputValue = e.target.value.replace(/\s+/g, '').trim();
                                                setUserNewPasswordDetails((prevState) => ({
                                                    ...prevState, confirmPassword: inputValue
                                                }));
                                                if (!isVisible2 && inputValue.length > 0) {
                                                    setIsVisibleText2(false);
                                                } else {
                                                    setIsVisibleText2(true);
                                                }
                                            }}
                                        />
                                        {
                                            isVisible2 ? <MdVisibilityOff onClick={handleVisiblityClick2} size="24px" color="#8189B0" /> : <MdVisibility onClick={handleVisiblityClick2} size="24px" color="#8189B0" />
                                        }
                                    </div>
                                    {errors.passwordsNotMatch &&
                                        <div className='w-full flex justify-start items-start'>
                                            <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t26')}</p>
                                        </div>
                                    }
                                    <button onClick={handleContinue} className="text-[18px] mt-[40px] rounded-lg pt-[10px] pb-[10px] w-full hover:bg-opacity-80 bg-gradient-to-r from-[#FFA803] to-[#FFD12E] ">{t('t52')}</button>

                                </>
                        }

                        <Dialog
                            open={open2}
                            onClose={handleClose2}
                            aria-labelledby="custom-dialog-title"
                            aria-describedby="custom-dialog-description"
                            className="backdrop-blur-sm"
                        >
                            <DialogContent className="bg-[#FFF6DA]">
                                {!isLoading &&
                                    <DialogContent
                                        id="custom-dialog-description"
                                        className="text-gray-600 text-md mt-2"
                                    >
                                        <div className='flex flex-col justify-center items-center text-center'>
                                            <img src='/images/passChanged.svg' alt='changed' />
                                            <div className='mt-[30px]'>{t('t78')}</div>
                                        </div>
                                    </DialogContent>
                                }

                            </DialogContent>
                            <DialogActions className="px-4 py-2 bg-[#FFF6DA]">
                                <Button
                                    onClick={() => {
                                        localStorage.clear();
                                        sessionStorage.clear()
                                        navigate('/loginas')
                                    }}
                                    className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                                    style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                >
                                    {t('t7')}
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <Dialog
                            open={openError}
                            onClose={handleCloseError}
                            aria-labelledby="custom-dialog-title"
                            aria-describedby="custom-dialog-description"
                            className="backdrop-blur-sm"
                        >
                            <DialogTitle
                                id="custom-dialog-title"
                                className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                            >
                                {t('t95')}
                            </DialogTitle>
                            <DialogContent className="bg-gray-50">
                                <DialogContentText
                                    id="custom-dialog-description"
                                    className="text-gray-600 text-md mt-2"
                                >
                                    {error}
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions className="px-4 py-2">
                                <Button
                                    onClick={handleCloseError}
                                    className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                                    style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                >
                                    {t('t96')}
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ForgotPasswordPage2;